import {
  sendOtpResponse,
  verifyOtpResponse,
} from "@services/models/Authentication/Authentication";
import axios, { AxiosInstance } from "axios";
import secureLocalStorage from "react-secure-storage";
import { API_URL } from "../../utils/globals";

class AuthenticationApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = axios.create({
      baseURL: API_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
    this.api.interceptors.request.use(
      (config) => {
        const token = secureLocalStorage.getItem("jwt");

        config.headers.Authorization = `Bearer ${token}`;

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  public async sendOtp(email: string): Promise<sendOtpResponse> {
    try {
      // Construct the URL with the email parameter
      const response = await this.api.get(
        `/cashierPanel/sendOTP?email=${encodeURIComponent(email)}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async verifyOtp(
    email: string,
    code: string,
    csrfToken: string
  ): Promise<verifyOtpResponse> {
    try {
      const response = await this.api.post(
        `/cashierPanel/verifyOTP`,
        {
          email,
          code,
        },
        {
          headers: {
            csrftoken: csrfToken,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const authenticationApiService = new AuthenticationApiService();
